import React from "react";

import { TagLine } from "components/customElements";
import EntitySnippet from "components/EntitySnippet";
import ProfileLogo from "components/ProfileLogo";
import { sectors } from "consts/sectors";
import profileAvatar from "assets/avatar.png";

import style from "./style.module.scss";

type Props = {
  item: any;
  type: "entities" | "insights";
};

const MostDiscussedSnippet = ({ item, type }: Props) => {
  if (item.type === "entities") {
    return (
      <EntitySnippet
        key={item.id}
        entity={item}
        containerClassName="px-0 space-x-0"
        logoClassName="mr-[5px]"
        hideTicker
      />
    );
  }

  const { account } = item;
  const tagline = type === "entities" ? item?.fulltext : item?.tagline;
  const logo =
    type === "entities"
      ? item?.logoUrl?.small
      : account?.avatarUrl?.small || profileAvatar;
  const icon = !logo
    ? sectors.find((s) => s.name === item?.sector)?.icon
    : null;

  return (
    <div key={item.id}>
      <div className={style.mostDiscussedItem}>
        <div className="mr-[5px]">
          <ProfileLogo
            profileURL={`${type}/${item?.slug}`}
            size="compact"
            logoSrc={logo}
            isSquare={type === "entities"}
            faFallbackLogo={icon}
          />
        </div>
        <div className={style.desc}>
          <div>
            <TagLine
              type={type}
              href={item?.slug}
              className="!text-[14px] !font-normal line-clamp-2"
              title={tagline}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MostDiscussedSnippet;
